import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faFlag, faGlobe, faLanguage} from '@fortawesome/free-solid-svg-icons';
import { Badge } from 'react-bootstrap';
import { faFontAwesome, faFontAwesomeFlag } from '@fortawesome/free-brands-svg-icons';

const LanguagesBadgeComponent = ({ amount, className = '' }) => {
  return (
    <Badge variant={!!amount ? 'secondary' : 'danger'} className={className}>
      <FontAwesomeIcon icon={faGlobe} className={'mr-1'} />
      {amount}
    </Badge>
  );
};

export { LanguagesBadgeComponent as LanguagesBadge };
